import {
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  HostListener,
  Input,
  ViewContainerRef,
  inject
} from "@angular/core";
import { PropertyTooltipComponent } from "@app/view/setup/resourcing/resources/property-tooltip/property-tooltip.component";

@Directive({ selector: "[appPropertyTooltip]" })
export class PropertyTooltipDirective {
  private viewContainerRef = inject(ViewContainerRef);
  private componentFactoryResolver = inject(ComponentFactoryResolver);

  @Input("appPropertyTooltip") externalPropertyReference: string;
  tooltipComponentRef: ComponentRef<PropertyTooltipComponent>;

  @HostListener("mouseenter") onMouseEnter() {
    if (!this.tooltipComponentRef) {
      const tooltipFactory =
        this.componentFactoryResolver.resolveComponentFactory(
          PropertyTooltipComponent
        );
      this.tooltipComponentRef =
        this.viewContainerRef.createComponent(tooltipFactory);
      this.tooltipComponentRef.instance.externalPropertyReference =
        this.externalPropertyReference;
      // Position and style your component
    }
  }

  @HostListener("mouseleave") onMouseLeave() {
    if (this.tooltipComponentRef) {
      this.tooltipComponentRef.destroy();
      this.tooltipComponentRef = null;
    }
  }
}
